module.exports = __webpack_public_path__ + "static/media/Anti-roedor.32c2a772.png";